import styles from "./RentTypeSwitch.module.css";

const currency = (value) =>
    new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    }).format(parseFloat(value) || 0);

const Option = ({ active, title, sub, amount, disabled, onClick }) => (
    <button
        type="button"
        role="radio"
        aria-checked={active}
        disabled={disabled}
        className={`${styles.opt} ${active ? styles.optActive : ""}`}
        onClick={onClick}
    >
        <span className={styles.radio}>{active && <span className={styles.radioDot} />}</span>
        <span className={styles.body}>
            <span className={styles.title}>{title}</span>
            <span className={styles.sub}>{sub}</span>
            {amount !== null && <span className={styles.amt}>{currency(amount)}</span>}
        </span>
    </button>
);

/*
 * Final month billing selector for the move-out statement.
 * The selected option's amount comes from the API (final_month_charge); the other
 * option's amount mirrors the backend formula and is for comparison only.
 */
const RentTypeSwitch = ({ value, onChange, statement, disabled }) => {
    const monthly = parseFloat(statement?.monthly_rent) || 0;
    const days = statement?.days_occupied;
    const daysInMonth = statement?.days_in_month;

    const fullPreview = statement ? monthly : null;
    const proratedPreview = statement
        ? (statement.is_full_stay ? monthly : Math.round((monthly * days / daysInMonth) * 100) / 100)
        : null;

    const amountFor = (type, preview) =>
        statement && value === type ? statement.final_month_charge : preview;

    const select = (type) => {
        if (type !== value) onChange(type);
    };

    // Tenant stayed the whole month: nothing to choose, always full month rent
    if (statement?.is_full_stay) {
        return (
            <div className={styles.root}>
                <div className={styles.label}>Final month billing</div>
                <div className={`${styles.opt} ${styles.optActive} ${styles.optStatic}`}>
                    <span className={styles.body}>
                        <span className={styles.title}>Full month rent</span>
                        <span className={styles.sub}>Tenant occupied all {daysInMonth} days</span>
                        <span className={styles.amt}>{currency(statement.final_month_charge)}</span>
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.root}>
            <div className={styles.label}>Final month billing</div>
            <div className={styles.grid} role="radiogroup" aria-label="Final month billing">
                <Option
                    active={value === "prorated"}
                    title="Prorated rent"
                    sub={statement?.is_full_stay ? "Full month occupied" : statement ? `${days} of ${daysInMonth} days` : "Charge days occupied"}
                    amount={amountFor("prorated", proratedPreview)}
                    disabled={disabled}
                    onClick={() => select("prorated")}
                />
                <Option
                    active={value === "full"}
                    title="Full month rent"
                    sub="Charge the whole month"
                    amount={amountFor("full", fullPreview)}
                    disabled={disabled}
                    onClick={() => select("full")}
                />
            </div>
        </div>
    );
};

export default RentTypeSwitch;
